import { render } from "./DetailLayout.vue?vue&type=template&id=726ee8fd&scoped=true"
import script from "./DetailLayout.vue?vue&type=script&lang=js"
export * from "./DetailLayout.vue?vue&type=script&lang=js"

import "./DetailLayout.vue?vue&type=style&index=0&id=726ee8fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726ee8fd"]])

export default __exports__